import {JSEncrypt} from 'jsencrypt'
// 公钥
const publicKey = 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDDbgs1BG3RveChScOs3LmMklKQWicKvM0w2AtFEbiPQpxSYt+g2PZdAuJ7j8t0NXfknLPOidn3WEN/JPcn+Ollw+zYEgSnJSeCjNNc1gX0wTNyAXnVVCuMMXJZjePz7xXDtxF22I3q96jiPd6KCtm/Fn0TVRXGUG+7fpKu6ww/iwIDAQAB'

// 加密
export function encrypt(txt) {
    const encryptor = new JSEncrypt()
    encryptor.setPublicKey(publicKey) // 设置公钥
    return encryptor.encrypt(txt) // 对需要加密的数据进行加密
}
